import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export function newSendEmail(datas:CreneauEmailSenderFD):Promise<CreneauEmailSender>{
    return dataFetcher(`creneau_email_senders`, {
        method:'post',
        body:datas
    })
}